<app-navbar-white></app-navbar-white>
<div class="section-conatiner container-fluid">
<div class="text-center">
<img loading="lazy" class="img-fluid lazyload img-b" src="{{imgSrc}}mail-sent.png" alt="image not found"> </div>
<div class="text-heading d-web">Thank you for getting in touch.</div>
<div class="text-heading d-mobile"><span>Thank you</span> for contacting us</div>
<div class="small-heading">Your message has been sent! We will get back to you within the next 48 hours.</div>
<div class="btn-container"><button type="button" [routerLink]="['/']" class="btn btn-submit" >Back to homepage</button></div>
</div>    
<app-footer-new></app-footer-new>